// extracted by mini-css-extract-plugin
export default {"app-message":"app-message_app-message__g1e--","success":"app-message_success__82laD","failure":"app-message_failure__q3bc6","show":"app-message_show__lGYV8"};